import { render, staticRenderFns } from "./trait_snp.vue?vue&type=template&id=011c798e&scoped=true&"
import script from "./trait_snp.vue?vue&type=script&lang=js&"
export * from "./trait_snp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011c798e",
  null
  
)

export default component.exports